import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { AxiosInstance } from "../../../../axios";
import { R_PER_PAGE } from "../../../../labels";
import { styled } from "@mui/material/styles";
import StatusCheck from "./StatusCheck";
import DatePickerSample from "../../DatePicker";
import Loader from "../../Loader";
import toast from "react-hot-toast";
function TestBatchView(props) {
  const moment = require("moment-timezone");
  const txtBSearch = useRef(null); //new code
  const currentDate = moment();
  let page = R_PER_PAGE;
  const locations = useLocation();
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const createFromDatePickerRef = useRef(null);
  const createToDatePickerRef = useRef(null);
  const {
    filStatus,
    filCateCode,
    fillClassMode,
    fillMedium,
    fillLoca,
    fillShd,
    fillAon,
    fillCOn,
    ftype,
    fillSearch,
  } = locations.state ? locations.state : {};

  // use state
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [updateListData, setUpdateListData] = useState();
  const [csvListData, setCsvListData] = useState([]);
  const [isOpen, setIsOpen] = useState({
    status: false,
    time: false,
    startDate: false,
    schedule: false,
    category: false,
    // course:false,
    medium: false,
    classMode: false,
    location: false,
  });
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [appData_on, setAppData_on] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [timedata, setTimedate] = useState({
    STime: "",
    TTime: "",
    name: "",
  });

  const [updateChipData, setUpdateChipData] = useState([]);
  const [location, setLocation] = useState([]);
  const [status, setStatus] = useState([]);
  const [appOn, setAppOn] = useState([]);
  const [appOn_on, setAppOn_on] = useState([]);
  const [typeOn, setTypeOn] = useState([]);
  const [time, setTime] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [classModes, setClassModes] = useState([]);
  const [mediums, setMedium] = useState([]);
  let filterStatus = [];
  let filterType = [];
  let filterTime = [];
  let filterSchedule = [];
  let filterClassMode = [];
  let filterMedium = [];
  let filterApplyed = [];
  let filterSearch = [];
  let filterApplyed_on = [];
  let filterLocation = [];

  const filterModeRef = useRef(null);
  const filterCategoryRef = useRef(null);
  const filterMediumRef = useRef(null);
  const filterLocationRef = useRef(null);
  const filterScheduleRef = useRef(null);
  const filterStartDateRef = useRef(null);
  const filterCreatedOnRef = useRef(null);
  const filterStatusRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterModeRef.current &&
        !filterModeRef.current.contains(event.target)
      ) {
        const hasType = updateChipData.some(
          (chipItem) => chipItem.type === "classMode"
        );
        if (hasType) {
          const updatedClassModeOn = updateChipData.filter(
            (chipItem) => chipItem.type === "classMode"
          );

          setClassModes(updatedClassModeOn);
        } else {
          setClassModes([]);
        }
        setIsOpen((prev) => ({ ...prev, classMode: false }));
      }
      if (
        filterCategoryRef.current &&
        !filterCategoryRef.current.contains(event.target)
      ) {
        const hasCategory = updateChipData.some(
          (chipItem) => chipItem.type === "type"
        );
        if (hasCategory) {
          const updatedSection = updateChipData.filter(
            (chipItem) => chipItem.type === "type"
          );
          setTypeOn(updatedSection);
        } else {
          setTypeOn([]);
        }
        setIsOpen((prev) => ({ ...prev, category: false }));
      }
      if (
        filterMediumRef.current &&
        !filterMediumRef.current.contains(event.target)
      ) {
        const hasMedium = updateChipData.some(
          (chipItem) => chipItem.type === "medium"
        );
        if (hasMedium) {
          const updatedMedium = updateChipData.filter(
            (chipItem) => chipItem.type === "medium"
          );
          setMedium(updatedMedium);
        } else {
          setMedium([]);
        }
        setIsOpen((prev) => ({ ...prev, medium: false }));
      }
      if (
        filterScheduleRef.current &&
        !filterScheduleRef.current.contains(event.target)
      ) {
        const hasSchedule = updateChipData.some(
          (chipItem) => chipItem.type === "schedule"
        );
        if (hasSchedule) {
          const updatedSchedule = updateChipData.filter(
            (chipItem) => chipItem.type === "schedule"
          );
          setSchedule(updatedSchedule);
        } else {
          setSchedule([]);
        }
        setIsOpen((prev) => ({ ...prev, schedule: false }));
      }
      if (
        filterStartDateRef.current &&
        !filterStartDateRef.current.contains(event.target)
      ) {
        const mismatchedDay = updateChipData.find(
          (chipItem) => chipItem.Days && chipItem.Days === appData.Days
        );

        if (mismatchedDay) {
          setAppData({
            FDate: "",
            TDate: "",
            Days: mismatchedDay.Days,
          });
          setAppOn([
            {
              FDate: "",
              TDate: "",
              Days: mismatchedDay.Days,
            },
          ]);
        } else {
          const mismatchedDate = updateChipData.find(
            (chipItem) =>
              chipItem.fdate === appData.FDate &&
              chipItem.edate === appData.TDate
          );

          if (mismatchedDate) {
            setAppData((prev) => ({
              ...prev,
              FDate: mismatchedDate.fdate,
              TDate: mismatchedDate.edate,
              Days: "",
            }));
            setAppOn([
              {
                FDate: mismatchedDate.fdate,
                TDate: mismatchedDate.edate,
                Days: "",
              },
            ]);
          } else {
            setAppData({
              FDate: "",
              TDate: "",
              Days: "",
            });
            setAppOn([]);
          }
        }

        setIsOpen((prev) => ({ ...prev, startDate: false }));
      }
      if (
        filterLocationRef.current &&
        !filterLocationRef.current.contains(event.target)
      ) {
        const hasLocation = updateChipData.some(
          (chipItem) => chipItem.type === "location"
        );
        if (hasLocation) {
          const updatedMedium = updateChipData.filter(
            (chipItem) => chipItem.type === "location"
          );
          setLocation(updatedMedium);
        } else {
          setLocation([]);
        }
        setIsOpen((prev) => ({ ...prev, location: false }));
      }
      if (
        filterCreatedOnRef.current &&
        !filterCreatedOnRef.current.contains(event.target)
      ) {
        const mismatchedDay = updateChipData.find(
          (chipItem) => chipItem.Days && chipItem.Days === appData_on.Days
        );
        if (mismatchedDay) {
          setAppData_on({
            FDate: "",
            TDate: "",
            Days: mismatchedDay.Days,
          });
          setAppOn_on([
            {
              FDate: "",
              TDate: "",
              Days: mismatchedDay.Days,
            },
          ]);
        } else {
          const mismatchedDate = updateChipData.find(
            (chipItem) =>
              chipItem.fdate === appData_on.FDate &&
              chipItem.edate === appData_on.TDate
          );

          if (mismatchedDate) {
            setAppData_on((prev) => ({
              ...prev,
              FDate: mismatchedDate.fdate,
              TDate: mismatchedDate.edate,
              Days: "",
            }));
            setAppOn_on([
              {
                FDate: mismatchedDate.fdate,
                TDate: mismatchedDate.edate,
                Days: "",
              },
            ]);
          } else {
            setAppData_on({
              FDate: "",
              TDate: "",
              Days: "",
            });
            setAppOn_on([]);
          }
        }
        setIsOpen((prev) => ({ ...prev, created_on: false }));
      }
      if (
        filterStatusRef.current &&
        !filterStatusRef.current.contains(event.target)
      ) {
        const hasStatus = updateChipData.some(
          (chipItem) => chipItem.type === "status"
        );

        if (hasStatus) {
          const updatedStatus = updateChipData.filter(
            (chipItem) => chipItem.type === "status"
          );
          setStatus(updatedStatus);
        } else {
          setStatus([]);
        }
        setIsOpen((prev) => ({ ...prev, status: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData]);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);
  // useEffect(() => {
  //   if (updateChipData.length === 0) {
  //     setUpdateChipData([
  //       { id: props.activeTab, name: "ActiveTab", type: "ActiveTab" },
  //     ]);
  //   }
  // }, [props.activeTab]);

  useEffect(() => {
    filterStatus = status;
  }, [status]);

  useEffect(() => {
    filterClassMode = classModes;
  }, [classModes]);

  useEffect(() => {
    filterSchedule = schedule;
  }, [schedule]);

  useEffect(() => {
    filterLocation = location;
  }, [location]);

  useEffect(() => {
    filterMedium = mediums;
  }, [mediums]);

  useEffect(() => {
    filterApplyed_on = appOn_on;
  }, [appOn_on]);

  useEffect(() => {
    filterType = typeOn;
  }, [typeOn]);

  useEffect(() => {
    filterApplyed = appOn;
  }, [appData]);

  useEffect(() => {
    filterTime = time;
  }, [time]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);

  // useEffect(() => {
  //   loadChipdata();
  // }, []);

  useEffect(() => {
    if (props.activeTab === 2 && updateChipData.length > 0) {
      loadListdata();
    }
  }, [updateChipData]);

  useEffect(() => {
    if (props.activeTab === 2) {
      if (filStatus && filStatus.length > 0 && ftype === 1) {
        setStatus(filStatus);
        filterStatus = filStatus;
      } else {
        setStatus(status);
        filterStatus = status;
      }
      if (filCateCode && filCateCode.length > 0 && ftype === 1) {
        setTypeOn(filCateCode);
        filterType = filCateCode;
      } else {
        setTypeOn(typeOn);
        filterType = typeOn;
      }
      if (fillClassMode && fillClassMode.length > 0 && ftype === 1) {
        setClassModes(fillClassMode);
        filterClassMode = fillClassMode;
      } else {
        setClassModes(classModes);
        filterClassMode = classModes;
      }
      if (fillMedium && fillMedium.length > 0 && ftype === 1) {
        setMedium(fillMedium);
        filterMedium = fillMedium;
      } else {
        setMedium(mediums);
        filterMedium = mediums;
      }
      if (fillSearch && fillSearch.length > 0 && ftype === 1) {
        filterSearch = [{ name: "" + fillSearch, type: "search" }];
        setSearchTerm(fillSearch);
      } else {
        if (searchTerm) {
          setSearchTerm(searchTerm);
          filterSearch = [{ name: "" + searchTerm, type: "search" }];
        }
      }
      if (fillLoca && fillLoca.length > 0 && ftype === 1) {
        setLocation(fillLoca);
        filterLocation = fillLoca;
      } else {
        setLocation(location);
        filterLocation = location;
      }
      if (fillShd && fillShd.length > 0 && ftype === 1) {
        setSchedule(fillShd);
        filterSchedule = fillShd;
      } else {
        setSchedule(schedule);
        filterSchedule = schedule;
      }

      if (fillAon && fillAon.length > 0 && ftype === 1) {
        setAppOn(fillAon);
        filterApplyed = fillAon;
      } else {
        setAppOn(appOn);
        filterApplyed = appOn;
      }
      if (fillCOn && fillCOn.length > 0 && ftype === 1) {
        setAppOn_on(fillCOn);
        filterApplyed_on = fillCOn;
      } else {
        setAppOn_on(appOn_on);
        filterApplyed_on = appOn_on;
      }
      loadChipdata();
    }
  }, [props.activeTab]);

  function updateStateData() {
    filterStatus = status;
    filterType = typeOn;
    filterApplyed = appOn;
    filterLocation = location;
    filterApplyed_on = appOn_on;
    filterTime = time;
    filterSchedule = schedule;
    filterClassMode = classModes;
    filterMedium = mediums;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  //sorting function

  const handleSort = (event, sortKey, type) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);

    let sortedList = updateListData.sort((a, b) => {
      // Check if the sortKey is a date
      if (type === "date") {
        // Convert date strings to timestamps for comparison
        let dateA = new Date(a[sortKey]).getTime();
        let dateB = new Date(b[sortKey]).getTime();

        if (dateA < dateB) {
          return order === "asc" ? -1 : 1;
        }
        if (dateA > dateB) {
          return order === "asc" ? 1 : -1;
        }
        return 0;
      } else if (sortKey === "dateTime") {
        let dateA = moment(a[sortKey], "DD/MM/YYYY HH:mm:ss");
        let dateB = moment(b[sortKey], "DD/MM/YYYY HH:mm:ss");

        if (dateA.isBefore(dateB)) {
          return order === "asc" ? -1 : 1;
        }
        if (dateA.isAfter(dateB)) {
          return order === "asc" ? 1 : -1;
        }
        return 0;
      } else {
        // Handle non-date fields
        if (a[sortKey] < b[sortKey]) {
          return order === "asc" ? -1 : 1;
        }
        if (a[sortKey] > b[sortKey]) {
          return order === "asc" ? 1 : -1;
        }
        return 0;
      }
    });
    setUpdateListData(sortedList);
  };

  // filter checkbox update

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (name === "Upcoming" || name === "Ongoing" || name === "Completed") {
      if (checked) {
        // setStatus([...status, value]);
        setStatus([...status, { id: value, name: name, type: "status" }]);
      } else {
        setStatus(status.filter((item) => item.id !== value));
      }
    } else if (names === "location") {
      if (checked) {
        // setStatus([...status, value]);
        setLocation([...location, { id: value, name: name, type: "location" }]);
      } else {
        setLocation(location.filter((item) => item.id !== value));
      }
    } else if (typename === "type") {
      if (checked) {
        setTypeOn([...typeOn, { name: value, type: "type" }]);
      } else {
        setTypeOn(typeOn.filter((item) => item.name !== value));
      }
    } else if (name === "Weekend" || name === "Regular") {
      if (checked) {
        setSchedule([{ id: value, name: name, type: "schedule" }]);
      } else {
        setSchedule(schedule.filter((item) => item.id !== value));
      }
    } else if (name === "Classroom" || name === "Online") {
      if (checked) {
        setClassModes([{ id: value, name: name, type: "classMode" }]);
      } else {
        setClassModes(classModes.filter((item) => item.id !== value));
      }
    } else if (name === "English" || name === "Tamil") {
      if (checked) {
        setMedium([{ id: value, name: name, type: "medium" }]);
      } else {
        setMedium(mediums.filter((item) => item.id !== value));
      }
    }
  };

  // handle search function
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      // 👇 Get input value
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  // --------New code (Search Icon)----
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };
  //-------end ------
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  //chips overall clear button
  const handleAllClear = () => {
    setSearchTerm("");
    setStatus([]);
    setSchedule([]);
    setTime([]);
    setLocation([]);
    setAppOn_on([]);
    setClassModes([]);
    setUpdateChipData([
      {
        id: props.activeTab ? props.activeTab : 2,
        name: "ActiveTab",
        type: "ActiveTab",
      },
    ]);
    setAppOn([]);
    setMedium([]);
    setTypeOn([]);
    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
    });
    setAppData_on({
      FDate: "",
      TDate: "",
      Days: "",
    });
  };

  // filter apply button

  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "appliedOn") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        startDate: false,
      });
    } else if (name === "appliedOn_on") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        created_on: false,
      });
    } else if (name === "location") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        location: false,
      });
    } else if (name === "type") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "time") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        time: false,
      });
    } else if (name === "schedule") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        schedule: false,
      });
    } else if (name === "classMode") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        classMode: false,
      });
    } else if (name === "medium") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        medium: false,
      });
    }
  };

  function loadListdata() {
    let tempstatus = [];
    let temptypeon = [];
    let tempsche = [];
    let tempclassMode = [];
    let tempLocanum = [];
    let templocation = [];
    let tempMedium = [];
    let tempstatusnum = [];
    status.map((obj) => {
      tempstatus.push(obj.id);
    });
    classModes.map((obj) => {
      tempclassMode.push(obj.name);
    });
    mediums.map((obj) => {
      tempMedium.push(obj.name);
    });
    location.map((obj) => {
      templocation.push(obj.id);
    });
    schedule.map((obj) => {
      tempsche.push(obj.name);
    });

    typeOn.map((obj) => {
      temptypeon.push(obj.name);
    });
    tempLocanum = templocation.map(Number);
    tempstatusnum = tempstatus.map(Number);
    let statusFilter = {
      category: typeOn.length > 0 ? temptypeon : "",
      status: status.length > 0 ? tempstatusnum : [],
      batch_type: schedule.length > 0 ? tempsche : "",
      medium: mediums.length > 0 ? tempMedium : "",
      class_mode: classModes.length > 0 ? tempclassMode : "",
      start_date: appOn.length > 0 ? appOn[0].fdate + " 00:00:00" : "",
      end_date: appOn.length > 0 ? appOn[0].edate + " 23:59:00" : "",
      start_time: time.length > 0 ? [time[0].STime] : "",
      c_start_date: appOn_on.length > 0 ? appOn_on[0].fdate : "",
      c_end_date: appOn_on.length > 0 ? appOn_on[0].edate : "",
      end_time: time.length > 0 ? [time[0].TTime] : "",
      search: searchTerm.length > 0 ? searchTerm : "",
      type: "1",
      location: location.length > 0 ? tempLocanum : "",
    };

    setIsLoading(true);
    AxiosInstance.post("api/batch/list", statusFilter)
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          setCurrentPage(1);
          const fiatabb = res.data.data;
          const fiata = fiatabb.sort((a, b) => {
            const dateA = moment(a.created_on, "DD/MM/YYYY hh:mm:ss A");
            const dateB = moment(b.created_on, "DD/MM/YYYY hh:mm:ss A");
            return dateB - dateA;
          });
          const bb = fiata.map((obj, index) => ({
            ...obj,
            statusOrder: StatusDate(obj, currentDate),
          }));

          const fiatssa = bb.sort((a, b) => {
            return a.statusOrder - b.statusOrder;
          });

          const serialNumberAddedData = fiatssa.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setUpdateListData(serialNumberAddedData);
          const statusMap = {
            0: "Upcoming",
            1: "Ongoing",
            2: "Completed",
          };
          const csvData = fiatssa.map((item) => ({
            name: item.name,
            category: item.category,
            category_class: item.category_class,
            class_mode: item.class_mode,
            fees: item.fees,
            medium: item.medium,
            batch_type: item.batch_type,
            location_name: item.location_name,
            started_dt: item.started_dt,
            created_on: item.created_on,
            status: statusMap[item.statusOrder] ?? "-",
          }));

          setCsvListData(csvData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }

  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterLocation.map((obj) => {
      tempArr.push(obj);
    });
    filterType.map((obj) => {
      tempArr.push(obj);
    });
    filterTime.map((obj) => {
      tempArr.push(obj);
    });

    filterApplyed_on.map((obj) => {
      tempArr.push(obj);
    });

    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });

    filterSchedule.map((obj) => {
      tempArr.push(obj);
    });

    filterClassMode.map((obj) => {
      tempArr.push(obj);
    });

    filterMedium.map((obj) => {
      tempArr.push(obj);
    });
    if (tempArr.length > 0) {
      setUpdateChipData(tempArr);
    } else {
      setUpdateChipData([
        {
          id: props.activeTab ? props.activeTab : 6,
          name: "ActiveTab",
          type: "ActiveTab",
        },
      ]);
    }
  }

  useEffect(() => {
    if (props.tabChanged) {
      handleAllClear();
      props.setTabChanged(false);
    }
  }, [props.tabChanged]);

  function StatusDate(course, currentDate) {
    let StausOrder = 0;
    const startMoment = moment(course.started_dt);
    const endMoment = startMoment.clone().add(course.duration, "months");

    if (
      currentDate.isBetween(
        startMoment.startOf("day").add(10, "hours"),
        endMoment.startOf("day").add(10, "hours"),
        null,
        "[]"
      )
    ) {
      StausOrder = 1;
    } else if (endMoment.isBefore(currentDate)) {
      StausOrder = 2;
    } else {
      StausOrder = 0;
    }

    return StausOrder;
  }

  const handleAppliedOn = (e) => {
    const { name, value, checked } = e.target;

    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: value,
          Days: "", // Reset Days when FDate or TDate is changed
        };

        const from = name === "FDate" ? value : updated.FDate;
        const to = name === "TDate" ? value : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        } else {
          setAppOn([
            {
              name: "",
              fdate: "",
              edate: "",
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    } else if (name === "Days") {
      if (checked) {
        // Set Days and reset FDate/TDate
        setAppData({
          FDate: "",
          TDate: "",
          Days: value,
        });

        const today = new Date();
        let fdate = "";
        let edate = "";
        let label = "";

        if (value === "Today") {
          fdate = edate = moment(today).format("YYYY-MM-DD");
          label = "Today";
        } else if (value === "Yesterday") {
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fdate = edate = moment(yesterday).format("YYYY-MM-DD");
          label = "Yesterday";
        } else if (value === "Tweek") {
          const start = moment(today).startOf("week").toDate();
          const end = moment(today).endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This week";
        } else if (value === "Lweek") {
          const start = moment(today)
            .subtract(1, "week")
            .startOf("week")
            .toDate();
          const end = moment(today).subtract(1, "week").endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last week";
        } else if (value === "Tmonth") {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);
          const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This month";
        } else if (value === "Lmonth") {
          const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const end = new Date(today.getFullYear(), today.getMonth(), 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last month";
        }

        setAppOn([
          {
            name: label,
            fdate,
            edate,
            type: "dayRange",
            Days: value,
          },
        ]);
      }
    }
  };
  const handleAppliedOn_on = (e) => {
    const { name, value, checked } = e.target;
    if (name === "FDate" || name === "TDate") {
      setAppData_on((prevState) => {
        const updated = {
          ...prevState,
          [name]: value,
          Days: "",
        };
        const from = name === "FDate" ? value : updated.FDate;
        const to = name === "TDate" ? value : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn_on([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        } else {
          setAppOn_on([
            {
              name: "",
              fdate: "",
              edate: "",
              type: "dateRange",
              Days: "",
            },
          ]);
        }
        return updated;
      });
    } else if (name === "Days") {
      if (checked) {
        // Set Days and reset FDate/TDate
        setAppData_on({
          FDate: "",
          TDate: "",
          Days: value,
        });
        const today = new Date();
        let fdate = "";
        let edate = "";
        let label = "";
        if (value === "Today") {
          fdate = edate = moment(today).format("YYYY-MM-DD");
          label = "Today";
        } else if (value === "Yesterday") {
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fdate = edate = moment(yesterday).format("YYYY-MM-DD");
          label = "Yesterday";
        } else if (value === "Tweek") {
          const start = moment(today).startOf("week").toDate();
          const end = moment(today).endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This week";
        } else if (value === "Lweek") {
          const start = moment(today)
            .subtract(1, "week")
            .startOf("week")
            .toDate();
          const end = moment(today).subtract(1, "week").endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last week";
        } else if (value === "Tmonth") {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);
          const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This month";
        } else if (value === "Lmonth") {
          const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const end = new Date(today.getFullYear(), today.getMonth(), 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last month";
        }
        setAppOn_on([
          {
            name: label,
            fdate,
            edate,
            type: "dayRange",
            Days: value,
          },
        ]);
      }
    }
  };

  // filter clear button
  const handleClear = (name) => {
    updateStateData();
    if (name === "appliedOn") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
      setIsOpen({
        ...isOpen,
        startDate: false,
      });
    } else if (name === "appliedOn_on") {
      setAppData_on({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn_on([]);
      filterApplyed_on = [];
      setIsOpen({
        ...isOpen,
        created_on: false,
      });
    } else if (name === "status") {
      // Clear the status array
      setStatus([]);
      filterStatus = [];
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "type") {
      setTypeOn([]);
      filterType = [];

      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "time") {
      setTime([]);
      filterTime = [];

      setIsOpen({
        ...isOpen,
        time: false,
      });
    } else if (name === "schedule") {
      setSchedule([]);
      filterSchedule = [];

      setIsOpen({
        ...isOpen,
        schedule: false,
      });
    } else if (name === "classMode") {
      setClassModes([]);
      filterClassMode = [];

      setIsOpen({
        ...isOpen,
        classMode: false,
      });
    } else if (name === "medium") {
      setMedium([]);
      filterMedium = [];

      setIsOpen({
        ...isOpen,
        medium: false,
      });
    } else if (name === "location") {
      // Clear the status array
      setLocation([]);
      filterLocation = [];
      setIsOpen({
        ...isOpen,
        location: false,
      });
    }
    loadChipdata();
  };

  // //   checking once again  -  handle delete function
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "status") {
      setStatus(status.filter((item) => item.id !== chipToDelete.id));
      filterStatus = status.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "location") {
      setLocation(location.filter((item) => item.id !== chipToDelete.id));
      filterLocation = location.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "type") {
      setTypeOn(typeOn.filter((item) => item.name !== chipToDelete.name));
      filterType = typeOn.filter((item) => item.name !== chipToDelete.name);
    } else if (chipToDelete.type === "dayRange") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    } else if (chipToDelete.type === "dayRange_on") {
      setAppData_on({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn_on([]);
      filterApplyed_on = [];
    } else if (chipToDelete.type === "time") {
      setTimedate({
        STime: "",
        TTime: "",
        name: "",
      });
      setTime([]);
      filterTime = [];
    } else if (chipToDelete.type === "schedule") {
      setSchedule(schedule.filter((item) => item.id !== chipToDelete.id));
      filterSchedule = schedule.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "classMode") {
      setClassModes(classModes.filter((item) => item.id !== chipToDelete.id));
      filterClassMode = classModes.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "medium") {
      setMedium(mediums.filter((item) => item.id !== chipToDelete.id));
      filterMedium = mediums.filter((item) => item.id !== chipToDelete.id);
    } else {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    }
    loadChipdata();
  };

  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      // First, update the date fields and reset Days
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "", // Reset Days when FDate or TDate is set
        };

        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;

        // Only set AppOn if both from and to dates are available
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };
  const handleChangeDate_app = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      setAppData_on((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };
        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn_on([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };
  useEffect(() => {
    if (locations.state) {
      // Optionally do something here if needed
    }
  }, [locations.state]);

  useEffect(() => {
    // Clear state only once AFTER all tabs are rendered
    if (locations.state) {
      const timer = setTimeout(() => {
        navigate(locations.pathname, { replace: true, state: null });
      }, 100); // give child tabs time to read it
      return () => clearTimeout(timer);
    }
  }, [locations.pathname]);
  // const handleChangeDate_app = (date, name) => {
  //   const dateFilter = moment(date).format("YYYY-MM-DD");
  //   if (name === "FDate" || name === "TDate") {
  //     setAppData_on((prevState) => ({ ...prevState, [name]: dateFilter }));
  //     const from = name === "FDate" ? dateFilter : appData_on.FDate;
  //     const to = name === "TDate" ? dateFilter : appData_on.TDate;
  //     const dateRange = `${from} - ${to}`;
  //     setAppOn_on([
  //       {
  //         name: dateRange,
  //         fdate: moment(from).format("YYYY-MM-DD"),
  //         edate: moment(to).format("YYYY-MM-DD"),
  //         type: "dayRange_on",
  //       },
  //     ]);
  //   }
  // };

  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        time: false,
        startDate: false,
        schedule: false,
        category: false,
        // course:false,
        medium: false,
        classMode: false,
        location: false,
        status: !prevState.status,
      }));
    } else if (boxName === "time") {
      setIsOpen((prevState) => ({
        startDate: false,
        schedule: false,
        category: false,
        // course:false,
        medium: false,
        classMode: false,
        status: false,
        location: false,
        time: !prevState.time,
      }));
    } else if (boxName === "location") {
      setIsOpen((prevState) => ({
        time: false,
        startDate: false,
        schedule: false,
        category: false,
        // course:false,
        medium: false,
        classMode: false,
        status: false,
        location: !prevState.location,
      }));
    } else if (boxName === "created_on") {
      setIsOpen((prevState) => ({
        schedule: false,
        category: false,
        // course:false,
        medium: false,
        classMode: false,
        status: false,
        location: false,
        time: false,
        startDate: false,
        created_on: !prevState.created_on,
      }));
    } else if (boxName === "startDate") {
      setIsOpen((prevState) => ({
        schedule: false,
        category: false,
        // course:false,
        medium: false,
        classMode: false,
        status: false,
        location: false,
        time: false,
        startDate: !prevState.startDate,
      }));
    } else if (boxName === "schedule") {
      setIsOpen((prevState) => ({
        category: false,
        created_on: false,
        medium: false,
        classMode: false,
        status: false,
        location: false,
        time: false,
        startDate: false,
        schedule: !prevState.schedule,
      }));
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        created_on: false,
        medium: false,
        classMode: false,
        status: false,
        location: false,
        time: false,
        startDate: false,
        schedule: false,
        category: !prevState.category,
      }));
    }
    // else if (boxName === "course") {
    //   setIsOpen((prevState) => ({
    //     ...prevState,
    //     course: !prevState.course,
    //   }));
    // }
    else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        category: false,
        created_on: false,
        classMode: false,
        status: false,
        location: false,
        time: false,
        startDate: false,
        schedule: false,
        medium: !prevState.medium,
      }));
    } else if (boxName === "classMode") {
      setIsOpen((prevState) => ({
        category: false,
        created_on: false,
        status: false,
        location: false,
        time: false,
        startDate: false,
        schedule: false,
        medium: false,
        classMode: !prevState.classMode,
      }));
    }
  };

  // generate pdf when user click download button
  const generatePDF = () => {
    const headers = [
      // "S.No",
      "Batch Name",
      // "Category",
      "Course Name",
      "Medium",
      "Test Mode",
      "Batch Amount",
      // "Schedule Preference",
      // "Location",
      // "Start Date",
      // "Created On",
      "Status",
    ];

    const rows = csvListData.map((item, index) => {
      return [
        // index + 1,
        item.name ?? "-",
        // item.category ?? "-",
        item.category_class ?? "-",
        item.medium ?? "-",
        item.class_mode ?? "-",
        item.fees ?? "-",
        // item.batch_type ?? "-",
        // item.location_name ?? "-",
        // item.started_dt ?? "-",
        // item.created_on ?? "-",
        item.status ?? "-",
      ];
    });

    // Navigate to preview page with PDF config
    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Test Batch Data",
          headers,
          rows,
          filename: "TestBatchData.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  // page count handle
  const handlePageCount = (e) => {
    const { name, value, checked } = e.target;
    if (name === "pageCount") {
      setRowsPerPage(parseInt(value));
      setCurrentPage(1);
      setUpdateListData([]);
    }
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData?.slice(start, end);

  const handleReadView = (id, type) => {
    // navigate(`/DetailViewBatch/${id}/${type}`);

    navigate(`/DetailViewBatch/${id}/${type}`, {
      state: {
        FSF: status,
        FCAF: typeOn,
        FCM: classModes,
        FME: mediums,
        FLO: location,
        FSP: schedule,
        FSTD: appOn,
        FCON: appOn_on,
        ftype: 1,
        FSEAR: searchTerm,
      },
    });
  };

  const csvHeaders = [
    { label: "Batch Name", key: "name" },
    { label: "Category", key: "category" },
    { label: "Course", key: "category_class" },
    { label: "Class Mode", key: "class_mode" },
    { label: "Batch Amount", key: "fees" },
    { label: "Medium", key: "medium" },
    { label: "Schedule Preference", key: "batch_type" },
    { label: "Location", key: "location_name" },
    { label: "Started Date", key: "started_dt" },
    { label: "Created On", key: "created_on" },
    { label: "Status", key: "status" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={
        props.activeTab === 2 ? " tab-content mt-4" : " tab-content mt-4 hide "
      }
      id="ex2-content"
    >
      {/* <div
        className={
          props.activeTab === 2
            ? "tab-pane fade show active p-0 col-md-12"
            : "tab-pane fade col-md-12 "
        }
      > */}
      <div className="row ">
        <div className="col-lg-3 col-md-12">
          <div class="input-group">
            <input
              ref={txtBSearch}
              type="text"
              class="Inputs"
              id="SearchInput"
              name="SearchInput"
              placeholder="Search by Name and course"
              onKeyDown={handleSearch}
            />
            <span
              class="input-group-text"
              id="SearchInput"
              onClick={handleSearchFocus}
            >
              <span className="material-icons" onClick={handleSearchFocus}>
                search
              </span>
            </span>
          </div>
        </div>
        <div className="col-lg-3 col-md-2"></div>
        <div className="col-lg-6  dflex col-md-12 justify-content-md-between justify-content-lg-end">
          <button type="button" className="ListViewBtn me-3">
            <span className="material-icons me-2 fs-4 align-middle text-white">
              file_download
            </span>
            <CSVLink
              data={csvListData}
              headers={csvHeaders}
              filename={"TestBatch.csv"}
            >
              Download as CSV
            </CSVLink>
          </button>
          <button
            type="button"
            className="ListViewBtn me-3"
            onClick={generatePDF}
          >
            <span className="material-icons me-2 fs-4 align-middle text-white">
              file_download
            </span>
            <Link to="javascript:void(0)">Download as PDF</Link>
          </button>
          <button type="button" className="ListViewBtn">
            <Link to="/CreateCourseBatch/1">
              <span className="material-icons me-2 fs-4 align-middle text-white">
                add_circle_outline
              </span>
            </Link>
            <Link to="/CreateCourseBatch/1"> Create New Test Batch</Link>
          </button>
        </div>
      </div>
      {updateChipData.filter((kl) => kl.name !== "ActiveTab").length > 0 ? (
        <div className="row mt-3">
          <div className="col-md-12 col-sm-12 col-xs-12 " id="paperil">
            <Paper
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData
                .filter((kl) => kl.name !== "ActiveTab")
                .map((data, index) => {
                  let icon;
                  let key = "" + data.name;
                  return (
                    <ListItem key={data}>
                      <Chip
                        icon={icon}
                        label={key}
                        onDelete={handleDelete(data, index)}
                      />
                    </ListItem>
                  );
                })}

              <ListItem>
                {/* <Chip
                      label=" Clear All Filters"
                      onClick={handleAllClear}
                    /> */}
                <a className="allclear" href="#" onClick={handleAllClear}>
                  Clear All Filters
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        <div></div>
      )}
      <div className="row mt-4 mx-0">
        <div className="col-md-12 table-responsive tableMinHeight p-0 px-0">
          <table className="table" id="example">
            <thead>
              <tr>
                {/* AIASA-000127  v1 - issues solved by lalitha */}
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "serialNumber")}
                  >
                    {" "}
                    S.No
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "serialNumber")}
                  >
                    {" "}
                    import_export{" "}
                  </span>
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "name")}
                  >
                    {" "}
                    Batch Name
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "name")}
                  >
                    {" "}
                    import_export{" "}
                  </span>
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "category")}
                  >
                    Category
                  </span>
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "category")}
                  >
                    {" "}
                    import_export{" "}
                  </span>{" "}
                  <span
                    class={` align-middle material-icons  ${
                      typeOn.length > 0 || isOpen.category ? "active_icons" : ""
                    }`}
                    onClick={(e) => handleFilter(e, "category")}
                  >
                    filter_list
                  </span>
                  {isOpen.category === true && (
                    <div className="filterBoxs p-1" ref={filterCategoryRef}>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="UPSC"
                              value="UPSC"
                              id="UPSC"
                              checked={typeOn.some((element) => {
                                if (element.name === "UPSC") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "UPSC", "type")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="UPSC"
                            >
                              UPSC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="TNPSC"
                              value="TNPSC"
                              id="TNPSC"
                              checked={typeOn.some((element) => {
                                if (element.name === "TNPSC") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "TNPSC", "type")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="TNPSC"
                            >
                              TNPSC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="RRB"
                              value="RRB"
                              id="RRB"
                              checked={typeOn.some((element) => {
                                if (element.name === "RRB") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "RRB", "type")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="RRB"
                            >
                              RRB
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="TET"
                              value="TET"
                              id="TET"
                              checked={typeOn.some((element) => {
                                if (element.name === "TET") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "TET", "type")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="TET"
                            >
                              TET
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="TRB"
                              value="TRB"
                              id="TRB"
                              checked={typeOn.some((element) => {
                                if (element.name === "TRB") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "TRB", "type")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="TRB"
                            >
                              TRB
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="TNUSRB"
                              value="TNUSRB"
                              id="TNUSRB"
                              checked={typeOn.some((element) => {
                                if (element.name === "TNUSRB") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "TNUSRB", "type")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="TNUSRB"
                            >
                              TNUSRB
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="SSC"
                              value="SSC"
                              id="SSC"
                              checked={typeOn.some((element) => {
                                if (element.name === "SSC") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "SSC", "type")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="SSC"
                            >
                              SSC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Banking"
                              value="Banking"
                              checked={typeOn.some((element) => {
                                if (element.name === "Banking") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Banking", "type")
                              }
                              id="Banking"
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="Banking"
                            >
                              Banking
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("type")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("type")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "category_class")}
                  >
                    Course
                  </span>

                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "category_class")}
                  >
                    import_export
                  </span>
                  {/* <span class="material-icons align-middle" onClick={(e)=>handleFilter(e,"course")}>
                    filter_list
                  </span>
                  {isOpen.course === true && (
                <div className="filterBoxs p-1">
                  <div className="row mt-4">
                    <div className="col-md-12">
                    <div class="form-check p-1">
                            <label
                              htmlFor="course"
                              className="d-flex form-label"
                            >
                               select Course
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            <select   class="FilterInputs"   id="course" name="course"  >
                        <option>Please select</option>
                      </select>
                           
                          </div>
                    </div>
                  </div>
                  <hr />
                  <div className="row mt-3">
                    <div className="col-md-4">
                      <span
                        className="clearFilter ms-2 "
                        style={{ cursor: "pointer" }}
                      >
                        Clear
                      </span>
                    </div>
                   <div className="col-md-8  col-8 col-sm-8">
                      <button
                        className="FilterButton"
                      >
                        Apply Filter
                      </button>
                    </div>
                  </div>
                </div>
                 )} */}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "class_mode")}
                  >
                    Test Mode
                  </span>
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "class_mode")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    class={` align-middle material-icons  ${
                      classModes.length > 0 || isOpen.classMode
                        ? "active_icons"
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "classMode")}
                  >
                    filter_list
                  </span>
                  {isOpen.classMode === true && (
                    <div className="filterBoxs p-1" ref={filterModeRef}>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Online"
                              value="1"
                              id="Online"
                              checked={classModes.some((element) => {
                                if (element.name === "Online") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Online")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="Online"
                            >
                              Online
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Classroom"
                              value="0"
                              id="Classroom"
                              checked={classModes.some((element) => {
                                if (element.name === "Classroom") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Classroom")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="Classroom"
                            >
                              Classroom
                            </label>
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("classMode")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("classMode")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "fees")}
                  >
                    Batch Amount
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "fees")}
                  >
                    import_export
                  </span>
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "medium")}
                  >
                    Medium
                  </span>

                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "medium")}
                  >
                    import_export
                  </span>
                  <span
                    class={` align-middle material-icons  ${
                      mediums.length > 0 || isOpen.medium ? "active_icons" : ""
                    }`}
                    onClick={(e) => handleFilter(e, "medium")}
                  >
                    filter_list
                  </span>
                  {isOpen.medium === true && (
                    <div className="filterBoxs p-1" ref={filterMediumRef}>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Tamil"
                              value="1"
                              id="Tamil"
                              checked={mediums.some((element) => {
                                if (element.id === "1") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) => handleCheckboxChange(e, "Tamil")}
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="Tamil"
                            >
                              Tamil
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="English"
                              value="0"
                              id="English"
                              checked={mediums.some((element) => {
                                if (element.id === "0") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "English")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="English"
                            >
                              English
                            </label>
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("medium")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("medium")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "batch_type")}
                  >
                    Schedule Preference
                  </span>

                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "batch_type")}
                  >
                    import_export
                  </span>
                  <span
                    class={` align-middle material-icons  ${
                      schedule.length > 0 || isOpen.schedule
                        ? "active_icons"
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "schedule")}
                  >
                    filter_list
                  </span>
                  {isOpen.schedule === true && (
                    <div className="filterBoxs p-1" ref={filterScheduleRef}>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Weekend"
                              value="0"
                              id="Weekend"
                              checked={schedule.some((element) => {
                                if (element.name === "Weekend") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Weekend")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="Weekend"
                            >
                              Weekend
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Regular"
                              value="1"
                              id="Regular"
                              checked={schedule.some((element) => {
                                if (element.name === "Regular") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Regular")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="Regular"
                            >
                              Regular
                            </label>
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("schedule")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("schedule")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "location")}
                  >
                    Location
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "location")}
                  >
                    import_export
                  </span>
                  <span
                    class={` align-middle material-icons  ${
                      location.length > 0 || isOpen.location
                        ? "active_icons"
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "location")}
                  >
                    filter_list
                  </span>
                  {isOpen.location === true && (
                    <div className="filterBoxs p-1" ref={filterLocationRef}>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Tambaram"
                              value="1"
                              id="Tambaram"
                              checked={location.some((element) => {
                                if (element.id === "1") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "location")
                              }
                            />
                            <label
                              class="form-check-label PinkText"
                              for="defaultCheck1"
                              htmlFor="Tambaram"
                            >
                              Tambaram
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Kanchipuram"
                              value="2"
                              id="Kanchipuram"
                              checked={location.some((element) => {
                                if (element.id === "2") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "location")
                              }
                            />
                            <label
                              class="form-check-label GreenText"
                              for="defaultCheck1"
                              htmlFor="Kanchipuram"
                            >
                              Kanchipuram
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Vellore"
                              value="3"
                              id="Vellore"
                              checked={location.some((element) => {
                                if (element.id === "3") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "location")
                              }
                            />
                            <label
                              class="form-check-label GreyText"
                              for="defaultCheck1"
                              htmlFor="Vellore"
                            >
                              Vellore
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Ch - Anna Nagar"
                              value="4"
                              id="Ch - Anna Nagar"
                              checked={location.some((element) => {
                                if (element.id === "4") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "location")
                              }
                            />
                            <label
                              class="form-check-label GreyText"
                              for="defaultCheck1"
                              htmlFor="Ch - Anna Nagar"
                            >
                              Ch - Anna Nagar
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("location")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("location")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "started_dt", "date")}
                  >
                    Start Date
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "started_dt", "date")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    onClick={(e) => handleFilter(e, "startDate")}
                    class={` align-middle material-icons  ${
                      appOn.length > 0 || isOpen.startDate ? "active_icons" : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.startDate === true && (
                    <div
                      className="filterBoxOne_Con container p-1"
                      ref={filterStartDateRef}
                    >
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="FDate"
                              className="d-flex form-label"
                            >
                              From Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                id="FDate"
                                type="date"
                                name="FDate"
                                value={appData.FDate}
                                className="FilterInputs"
                                onChange={handleAppliedOn}
                                placeholder="FDate"
                                autoComplete="FDate"
                                required
                              /> */}
                            <DatePickerSample
                              IconInput={"filterIocnBoxInput"}
                              class={"FilterInputs"}
                              name={"FDate"}
                              handleChange={handleChangeDate}
                              fieldInput={appData.FDate}
                              txtAdMDob={fDatePickerRef}
                              // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="TDate "
                              className="d-flex form-label"
                            >
                              To Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                id="TDate"
                                type="date"
                                name="TDate"
                                value={appData.TDate}
                                className="FilterInputs"
                                placeholder="TDate"
                                onChange={handleAppliedOn}
                                autoComplete="TDate"
                                required
                              /> */}
                            <DatePickerSample
                              class={"FilterInputs"}
                              IconInput={"filterIocnBoxInput"}
                              name={"TDate"}
                              handleChange={handleChangeDate}
                              fieldInput={appData.TDate}
                              txtAdMDob={tDatePickerRef}
                              minDate={appData.FDate}
                              // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              id="Today"
                              value="Today"
                              checked={appData.Days === "Today"}
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Today"
                              htmlFor="Today"
                              style={{ fontWeight: "bold" }}
                            >
                              Today
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Yesterday"
                              checked={appData.Days === "Yesterday"}
                              id="Yesterday"
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Yesterday"
                              htmlFor="Yesterday"
                              style={{ fontWeight: "bold" }}
                            >
                              Yesterday
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tweek"
                              checked={appData.Days === "Tweek"}
                              id="Tweek"
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tweek"
                              htmlFor="Tweek"
                              style={{ fontWeight: "bold" }}
                            >
                              This week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Lweek"
                              checked={appData.Days === "Lweek"}
                              id="Lweek"
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lweek"
                              htmlFor="Lweek"
                              style={{ fontWeight: "bold" }}
                            >
                              Last week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tmonth"
                              checked={appData.Days === "Tmonth"}
                              id="Tmonth"
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tmonth"
                              htmlFor="Tmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              This month
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              checked={appData.Days === "Lmonth"}
                              value="Lmonth"
                              id="Lmonth"
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lmonth"
                              htmlFor="Lmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              Last month
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("appliedOn")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("appliedOn")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "created_on", "dateTime")}
                  >
                    Created On
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "created_on", "dateTime")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    onClick={(e) => handleFilter(e, "created_on")}
                    class={` align-middle material-icons  ${
                      appOn_on.length > 0 || isOpen.created_on
                        ? "active_icons"
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.created_on === true && (
                    <div
                      className="filterBoxOne_Con container p-1"
                      ref={filterCreatedOnRef}
                    >
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="FDate"
                              className="d-flex form-label"
                            >
                              From Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                id="FDate"
                                type="date"
                                name="FDate"
                                value={appData_on.FDate}
                                className="FilterInputs"
                                onChange={handleAppliedOn_on}
                                placeholder="FDate"
                                autoComplete="FDate"
                                required
                              /> */}
                            <DatePickerSample
                              IconInput={"filterIocnBoxInput"}
                              class={"FilterInputs"}
                              name={"FDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appData_on.FDate}
                              txtAdMDob={createFromDatePickerRef}
                              // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="TDate "
                              className="d-flex form-label"
                            >
                              To Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                                id="TDate"
                                type="date"
                                name="TDate"
                                value={appData_on.TDate}
                                className="FilterInputs"
                                placeholder="TDate"
                                onChange={handleAppliedOn_on}
                                autoComplete="TDate"
                                required
                              /> */}
                            <DatePickerSample
                              class={"FilterInputs"}
                              IconInput={"filterIocnBoxInput"}
                              name={"TDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appData_on.TDate}
                              txtAdMDob={createToDatePickerRef}
                              minDate={appData_on.FDate}
                              // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              id="Today"
                              value="Today"
                              checked={appData_on.Days === "Today"}
                              onChange={handleAppliedOn_on}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Today"
                              htmlFor="Today"
                              style={{ fontWeight: "bold" }}
                            >
                              Today
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Yesterday"
                              checked={appData_on.Days === "Yesterday"}
                              id="Yesterday"
                              onChange={handleAppliedOn_on}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Yesterday"
                              htmlFor="Yesterday"
                              style={{ fontWeight: "bold" }}
                            >
                              Yesterday
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tweek"
                              checked={appData_on.Days === "Tweek"}
                              id="Tweek"
                              onChange={handleAppliedOn_on}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tweek"
                              htmlFor="Tweek"
                              style={{ fontWeight: "bold" }}
                            >
                              This week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Lweek"
                              checked={appData_on.Days === "Lweek"}
                              id="Lweek"
                              onChange={handleAppliedOn_on}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lweek"
                              htmlFor="Lweek"
                              style={{ fontWeight: "bold" }}
                            >
                              Last week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tmonth"
                              checked={appData_on.Days === "Tmonth"}
                              id="Tmonth"
                              onChange={handleAppliedOn_on}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tmonth"
                              htmlFor="Tmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              This month
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              checked={appData_on.Days === "Lmonth"}
                              value="Lmonth"
                              id="Lmonth"
                              onChange={handleAppliedOn_on}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lmonth"
                              htmlFor="Lmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              Last month
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("appliedOn_on")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("appliedOn_on")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                {/* <th id="th">
                    Time{" "}
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "start_time")}
                    >
                      import_export
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleFilter(e, "time")}
                    >
                      filter_list
                    </span>
                    {isOpen.time === true && (
                      <div className="filterBoxs p-1">
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div class="form-check p-1">
                              <label
                                htmlFor="startTime"
                                className="d-flex form-label"
                              >
                                Start Time
                                <span
                                  data-required="true"
                                  aria-hidden="true"
                                ></span>
                              </label>
                              <input
                                id="STime"
                                type="time"
                                step="1"
                                name="STime"
                                className="FilterInputs"
                                placeholder="STime"
                                autoComplete="STime"
                                required
                                value={timedata.STime}
                                onChange={handleTime}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div class="form-check p-1">
                              <label
                                htmlFor="endTime"
                                className="d-flex form-label"
                              >
                                End Time
                                <span
                                  data-required="true"
                                  aria-hidden="true"
                                ></span>
                              </label>
                              <input
                                id="TTime"
                                type="time"
                                step="1"
                                name="TTime"
                                className="FilterInputs"
                                placeholder="TTime"
                                autoComplete="TTime"
                                required
                                value={timedata.TTime}
                                onChange={handleTime}
                              />
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("time")}
                            >
                              Clear
                            </span>
                          </div>
                         <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              onClick={() => handleApplyFilter("time")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </th> */}
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "Status")}
                  >
                    Status
                  </span>{" "}
                  {/* <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "Status")}
                    >
                      import_export
                    </span>{" "} */}
                  <span
                    class={` align-middle material-icons  ${
                      status.length > 0 || isOpen.status ? "active_icons" : ""
                    }`}
                    onClick={(e) => handleFilter(e, "status")}
                  >
                    filter_list
                  </span>
                  {/* 0 → past, 1→ present, 2→ future */}
                  {isOpen.status === true && (
                    <div className="filterBoxssss p-1" ref={filterStatusRef}>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Upcoming"
                              value="2"
                              id="Upcoming"
                              checked={status.some((element) => {
                                if (element.id === "2") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Upcoming")
                              }
                            />
                            <label
                              class="form-check-label PinkText"
                              for="defaultCheck1"
                              htmlFor="Upcoming"
                            >
                              Upcoming
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Ongoing"
                              value="1"
                              id="Ongoing"
                              checked={status.some((element) => {
                                if (element.id === "1") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Ongoing")
                              }
                            />
                            <label
                              class="form-check-label GreenText"
                              for="defaultCheck1"
                              htmlFor="Ongoing"
                            >
                              Ongoing
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Completed"
                              value="0"
                              id="Completed"
                              checked={status.some((element) => {
                                if (element.id === "0") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Completed")
                              }
                            />
                            <label
                              class="form-check-label GreyText"
                              for="defaultCheck1"
                              htmlFor="Completed"
                            >
                              Completed
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("status")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("status")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  {" "}
                  <span className="text_th">Action</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData?.length === 0 ? (
                <tr>
                  <td
                    colspan="15"
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #dee2e6",
                    }}
                  >
                    No record to display
                  </td>
                </tr>
              ) : (
                currentData?.map((course, index) => (
                  <tr key={index} title={course.id}>
                    <td id="td">{course.serialNumber}</td>
                    <td id="td">
                      {course.name}({course.section})
                    </td>
                    <td id="td">{course.category}</td>
                    <td id="td"> {course.category_class}</td>
                    <td id="td">
                      {" "}
                      {course.class_mode === "ClassRoom"
                        ? "Classroom "
                        : course.class_mode}
                    </td>
                    <td id="td">{course.fees}</td>
                    <td id="td">{course.medium}</td>
                    <td id="td">{course.batch_type}</td>
                    <td id="td">{course.location_name}</td>
                    <td id="td">
                      {moment(course.started_dt).format("YYYY-MM-DD")}
                    </td>
                    <td id="td">
                      <div>
                        {" "}
                        {moment(
                          course.created_on,
                          "DD/MM/YYYY h:mm:ss A"
                        ).format("DD/MM/YYYY")}{" "}
                      </div>
                      <div>
                        {" "}
                        {moment(
                          course.created_on,
                          "DD/MM/YYYY h:mm:ss A"
                        ).format("h:mm:ss A")}
                      </div>
                    </td>
                    {/* {moment(course.started_dt).isBefore(currentDate) &&
                      currentDate.isBefore(
                        moment(course.started_dt).add(1, "day").startOf("day")
                      ) ? (
                        <td id="td">
                          <span className="GreenTexts">OnGoing</span>
                        </td>
                      ) : (moment(course.started_dt).isSame(
                          currentDate,
                          "day"
                        ) &&
                          currentDate.isBefore(tenAM)) ||
                        currentDate.isBetween(
                          tenAM,
                          moment(course.started_dt).add(1, "day").startOf("day")
                        ) ? (
                        <td id="td">
                          <span className="PinkText">Upcoming</span>
                        </td>
                      ) : (
                        <td id="td">
                          <span className="GreyText">completed</span>
                        </td>
                      )} */}
                    <StatusCheck status={course} />

                    <td id="td">
                      <button
                        className="button"
                        onClick={() => handleReadView(course.id, 1)}
                      >
                        <span class="material-icons">visibility</span>
                      </button>
                      {/* <button
                          className="button me-2"
                          onClick={() => handleEditView(course.type,course.id)}
                        >
                          <span class="material-icons">edit</span>
                        </button>{" "} */}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="row mt-3 ">
        <div className="col-md-12">
          <div className="pag w-100 dflexcenter">
            <span className="ipage">Items Per Page</span>
            <select
              name="pageCount"
              id="pageCount"
              defaultValue={rowsPerPage}
              onChange={handlePageCount}
              className="ms-2"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <span className="pagenumber ms-2">
              {" "}
              {updateListData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0}{" "}
              -
              {updateListData?.length < currentPage * rowsPerPage
                ? updateListData?.length
                : currentPage * rowsPerPage}{" "}
              of {updateListData?.length}
            </span>
            <button
              className="prev_button ms-2 me-2"
              onClick={(e) => handlePrev(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <span class="material-icons">chevron_left</span>
            </button>
            <button
              className="prev_button"
              onClick={() => handleNext(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <span class="material-icons">chevron_right</span>
            </button>
          </div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
}

export default TestBatchView;
